export class FbGeneralModalConfiguration {


    constructor(public title : string, public label? : string, public action? : Function, public closeAction? : Function,public styleClass? : string,public closable : boolean = false,public colorbutton1? : string,public colorbutton2? : string,public labelButton1?: string,public labelButton2?: string,public stringList?: string[], public iconButton1?: string, public iconButton2?: string ){}

    public static create = (title : string) => new FbGeneralModalConfiguration(title);

    public setLabel = (label : string) => {this.label = label; return this;}
    public setAction = (action : Function) => {this.action = action; return this;}
    public setCloseAction = (action : Function) => {this.closeAction = action; return this;}
    public setClosable = (closable : boolean) => {this.closable = closable; return this;}
    public setStyleClass = (styleClass : string) => {this.styleClass = styleClass; return this;}
    public setColorButton1 = (colorbutton1 : string)  => {this.colorbutton1 = colorbutton1; return this;}
    public setColorButton2 = (colorbutton2 : string)  => {this.colorbutton2 = colorbutton2; return this;}
    public setLabelButton1 = (labelButton1 : string)  => {this.labelButton1 = labelButton1; return this;}
    public setLabelButton2 = (labelButton2 : string)  => {this.labelButton2 = labelButton2; return this;}
    public setStringList = (stringList : string[])  => {this.stringList = stringList; return this;}
    public setIconButton1 = (iconButton1 : string)  => {this.iconButton1 = iconButton1; return this;}
    public setIconButton2 = (iconButton2 : string)  => {this.iconButton2 = iconButton2; return this;}
}
